import React from 'react';
import PendingPreAssessments from './PendingPreAssessments';

export default function PendingImpactReport() {
  return <PendingPreAssessments title="Pending Impact Report to Download" type="download" impactReport />;
}
